import classes from "./Footer.module.scss";
import packageJson from "../../../package.json";
import { FormattedMessage } from "react-intl";
import messages from "./module/messages";

const Footer = () => {
  const appVersion = packageJson.version;
  return (
    <footer className={classes["footer__wrapper"]}>
      <FormattedMessage {...messages.version} />
      <span className={classes["app-version"]}>{appVersion}</span>
    </footer>
  );
};

export default Footer;
